import { AbstractStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./attachmentsActions";

interface PreviewItem {
    fileKey: string;
    stringImage: string;
}

export class AttachmentsPreviewStore extends AbstractStore<PreviewItem>{
    constructor() {
        super(x => x.fileKey);
        Dispatcher
            .onfunction(Actions.preview, result => this.updateOrAdd({ fileKey: result.fileKey, stringImage: result.result! }));
    }
}

export default new AttachmentsPreviewStore();